<template>
  <div class="nps">
    <div class="d-flex flex-wrap">
      <div
        v-for="answer in question.answers"
        :key="answer.id"
        class="nps-button"
        :class="selectedClass(answer)"
        @click="rate(answer)"
      >
        {{ answer.the_answer }}
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { mapState } from 'pinia'
import { useSurveyResponseStore } from '@app/stores/SurveyResponseStore.ts'
import { useValidationStore } from '@/survey/stores/ValidationStore.ts'

export default {
  props: {
    question: { type: Object, required: true },
  },
  emits: ['change'],
  data() {
    return {
      selectedNps: null,
    }
  },
  computed: {
    ...mapState(useSurveyResponseStore, ['surveyResponses', 'findResponseByQuestionId']),
    ...mapState(useValidationStore, ['addError', 'registerValidationFunction', 'validate']),
    response() {
      return this.findResponseByQuestionId(this.question.id)
    },
  },
  mounted() {
    this.registerValidationFunction(this.question.id, this._validate)
    this.selectedNps = this.response?.value_answer
  },
  methods: {
    rate(answer) {
      if (this.selectedNps == answer.the_answer) return

      this.selectedNps = answer.the_answer
      const responseData = {
        answer_id: answer.id,
        question_id: this.question.id,
        response_id: this.response?.id,
        value_answer: answer.the_answer,
      }

      this.validate(this.question.id)
      this.$emit('change', responseData)
    },
    selectedClass(answer) {
      return answer.the_answer == this.selectedNps ? 'selected' : ''
    },
    _validate() {
      if (this.question.required && !this.selectedNps) {
        this.addError(this.question.id, 'Please select an answer')
      }
    },
  },
}
</script>
<style lang="sass" scoped>
@media (max-width:500px)
  .nps
    .nps-button
      width: 48%
      min-width: 48%
</style>
